import { Routes } from "@angular/router";

export const routes: Routes = [
  {
    path: "search/index",
    loadChildren: () => import("./home/home-module").then((m) => m.HomeModule),
  },
  {
    path: "Account/Login",
    loadChildren: () =>
      import("./login/login-module").then((m) => m.LoginModule),
  },
  {
    path: "result",
    loadChildren: () =>
      import("./result/result-module").then((m) => m.ResultModule),
  },
  {
    path: "account",
    loadChildren: () =>
      import("./account/account-module").then((m) => m.AccountModule),
  },

  {
    path: "print",
    loadChildren: () =>
      import("./reports/reports-module").then((m) => m.ReportsModule),
  },
  {
    path: "admin/index",
    loadChildren: () =>
      import("./admin/admin-module").then((m) => m.AdminModule),
  },

  {
    path: "",
    loadChildren: () =>
      import("./login/login-module").then((m) => m.LoginModule),
  },
];
